<template>
    <div v-if="dataItem != null" class="page white_bg" style="padding-bottom: 60px; min-height: 100vh;">
        <!-- 课程组合 -->
        <header class="pageHeader paddingB20" style="padding-top:0;">
            <!-- 248c342c2daa3b6a5e1f6af7e8b46b8a -->
            <!-- 6b8d2b8ec6ab23df9e68de0ed89f657b -->
            <!-- <div class="bg cover" :style="dataItem ? 'background-image: url(' + dataItem.coverImg + ')' : ''+';background-repeat:no-repeat;'"> -->
            <div class="bg cover" >
                <div style="
                width:100%;
                height:100%;
                position: absolute;
                top:0;
                background: #2f2f2f;
                z-index: 9;
                opacity: 0.2;">
                    <!-- <img src="voiceCourse/bg_album.svg" alt=""> -->
                </div>
                <div style="
                background-repeat:no-repeat;
                filter:blur(12px);
                width:105%;
                height:105%;
                background-size:105% 105%;
                margin-left:-2%;
                margin-top:-2%"
                :style="{'background-image':'url(' +dataItem.coverImg+')'}"></div>
                <!-- <img style="width:100%;height:100%;" src="" alt=""> -->
                <!-- <img style="width:100%;height:100%;" :src="dataItem ? dataItem.coverImg : ''" alt=""> -->
            </div>
            <div class="flexLayout relative" style="z-index: 2; padding-left: 24px; padding-bottom: 18px;padding-top:68px;">
                <div class="imageArea"  style="width: 102px;heigh:102px">
                    <img :src="dataItem ? dataItem.coverImg : ''" class="block bgEEE roundBorder8 cover" style="width:102px;height: 102px;"/>
                </div>
                <div style="overflow:hidden;" class="flexItem paddingH12">
                    <div style="margin-top:13px" class="font18r white bold dhidden">
                           {{dataItem ? dataItem.title : ''}}
                    </div>
                    <!-- <div class="font12r white" style="margin-bottom:15px;margin-top:10px">
                        {{dataItem ? dataItem.click : 0}}人收听
                    </div> -->
                    <div class="clearfix" style="margin-top: 33px;">


                        <div class=" font12r white floatL">{{dataItem ? dataItem.click : 0}}人收听</div>
                        <div style="margin-right:19px;" class="floatR font12r white" >
                            已更新{{dataItem ? dataItem.segCount : 0}}本
                            <!-- 播放全部按钮 -->
                            <!-- <img class="block" src="icon/red_play_all_button.svg" style="width: 112px; height: 55px"
                                 @click="playAll()"/> -->
                        </div>
                    </div>
                </div>

            </div>
              <div class="album-introde">
                简介：{{dataItem ? dataItem.introduce : ''}}
            </div>
        </header>

        <div class="body white_bg" style="position: relative; top: -20px;">
            <div class="inner paddingH20 paddingV20">
                <div class="title bold grey20 marginB12">
                    学习列表
                    <img class="marginL8" width="10" height="14" src="icon/learnIcon/bar-code.png"/>
                </div>
                <div class="voiceCourseList">
                    <div class="tfont alignCenter" v-show="status == 'ready' &&  dataItem.audioSeg < 1">
                        列表暂无内容
                    </div>
                    <div class="voiceCourseItem flexLayout" @click="getAlbumID(item.id)" v-for="(item , index) in dataItem.audioSeg"
                        :key="index">
                        <div class="flexItem">
                            <div class="font14r grey10">
                                <span v-if="index<9" style="margin-right:8px;">{{ '0'+ (index+1) }}</span>
                                <span v-else style="margin-right:8px;">{{ index+1 }}</span>
                                {{item.title}}
                            </div>
                            <div class="flexLayout">
                                 <div class="grey75 font10r" style="margin-right:20px">时长{{formatTime(item.duration)}}</div>
                                <!-- <div class="grey75 font10r">{{item.auditStatus}}</div> -->
                            </div>

                        </div>
                        <div style="width: 24px;" class="paddingT4">
                            <!-- <img class="size24" src="voiceCourse/item_option.svg"/> -->
                            <img style="opacity:.5" src="icon/learnIcon/choiceness-play.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a class="fixedBackIcon" href="javascript:;" @click="back()">
            <img class="icon" src="icon/back_icon.svg"/>
        </a>
        <a class="fixedShareIcon" href="javascript:;" @click="share()">
            <img class="icon" src="icon/white_circle_share_icon.svg"/>
        </a>

<!--        <div class="fixedBottom white_bg" style="box-shadow: 0px -5px 8px rgba(123, 123, 123, 0.1);">-->
<!--            <div class="inner paddingH12 paddingT4 flexLayout">-->
<!--                <div style="width: 48px;">-->
<!--                    <img class="size48 circle cover" :src="dataItem.coverImg"/>-->
<!--                </div>-->
<!--                <div class="flexItem paddingL8" style="padding-top: 12px;width:100%">-->
<!--                    <div class="font16r grey20 bold ellipsisOverflowText fl"-->
<!--                         style="height: 1.375em; line-height: 1.375em; width: 9em;">司凤要去攻打少阳...</div>-->
<!--                    <div class="fr" style="margin-right: 50px;">-->
<!--                        <i class="icon pauseButton"></i>-->
<!--                    </div>-->
<!--                    <div class="fr" style="margin-right: -62px;">-->
<!--                        <i class="icon nextButton"></i>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

    </div>
    <div v-else>
        没数据
    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '../../appConfig';

// util
import consoleHelper    from '@util/consoleHelper';
import numberHelper     from '@util/numberHelper';
import browserHelper    from '@util/browserHelper';
import deviceHelper     from '@util/deviceHelper';
import appHelper        from '@util/appHelper';
import wechatHelper     from '@util/wechatHelper';

const config = {
    apiConfig : {
        get : {
            url : '/portal/api/audio/album',
             dataPath : 'data',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    },
    demoList : [
        {
            title:'幼儿园健康领域教学活动设计',
            timer:'11:30',
            duration: 456,
            state:'更新完毕'
        },
        {
            title:'细菌从哪里来进入身体的',
            timer:'11:30',
            duration: 456,
            state:'更新完毕'
        },
        {
            title:'褚璇玑居然是天界战胜转世下凡历劫',
            timer:'11:30',
            duration: 456,
            state:'更新完毕'
        },
        {
            title:'腾蛇大人在人间沦落为战神灵兽',
            timer:'11:30',
            duration: 456,
            state:'更新完毕'
        },
        {
            title:'司凤要去攻打少阳派了',
            timer:'11:30',
            duration: 456,
            state:'更新完毕'
        },
    ]

};

export default {
    name: "voiceAlbum",
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : '语音课程',
            apiConfig : config.apiConfig,
            enableDataItem : true,
            autoLoadDataItem: appConfig.mode != 'demo'
        }
    },
    methods : {

        onLoadDataItem() {

            appHelper.setTitle(this.dataItem.title);

            // set wechat share
            // let wechatShareOptions = {
            //     title   : appHelper.getTitle(),
            //     desc    : this.dataItem.introduce,
            //     imgUrl  : this.dataItem.coverImg || appHelper.getAppIcon() // 分享图标
            // };
            //
            // this.setWechatShare(wechatShareOptions);
        },

        getAlbumID(id){
            // this.$router.push({name:'voiceCourseDetail',params: {id:id}})
            this.$router.push('/voiceCourse/detail/' + id);
        },

        formatTime(time){
            let minute =  parseInt(time/60);
            let second = time%60;
            let strMinute,strSecond;

            if(minute < 10){
               strMinute = '0'+minute;
            }else{
                strMinute = minute;
            }
            if(second < 10){
               strSecond = '0'+second;
            }else{
                strSecond = second;
            }
            return strMinute+':'+strSecond
        },

        /**
         * format seconds to 'xx:xx'
         * @param   Number  seconds
         * @return {string}
         */
        formatDuration(seconds) {
            let secondPart = seconds % 60;
            let minutePart = Math.floor((seconds - secondPart) / 60);

            secondPart < 10 ? secondPart = '0' + secondPart : null;
            minutePart < 10 ? minutePart = '0' + minutePart : null;

            return minutePart + ':' + secondPart;
        },
        back(){
            appHelper.back(this)
        },
        share(){
              appHelper.shareAlert();
        },

        playAll() {
            window.tempVoiceList = this.dataItem.audioSeg;
            appHelper.redirect('/voiceCourse/detail/');
        },

        // setWechatShare : function() {
        //
        //     if (!this.dataItem)
        //     {
        //         return;
        //     }
        //
        //     let wechatShareOptions = {
        //         title   : appHelper.getTitle(),
        //         desc    : this.dataItem.desc,
        //         link    : location.href,
        //         imgUrl  : this.dataItem.coverImg || appHelper.getAppIcon() // 分享图标
        //     };
        //
        //     wechatHelper.setShare(wechatShareOptions);
        // }

    },
    created(){
        //获取id
        // this.apiConfig.list.params.id =  this.$route.params.id

    },
    mounted() {

        const id = this.$route.params.id || '';

        if (appConfig.mode == 'demo')
        {
            setTimeout(() => {
                for (let i=1; i<=120; i++)
                {
                    this.dataItem.audioSeg.push(config.demoList[numberHelper.getRandomInteger(config.demoList.length)]);
                }
            }, 3000)

        }

    }
}
</script>

<style lang="scss" scoped>

.tfont{

    font-size: 14px;

    font-weight: 400;
    color: #999999;

}


.album-introde{
    width: 90%;
    z-index: 4;
    position: relative;
    margin: 0 auto;
    margin-bottom: 20px;
    font-size: 12px;

    font-weight: 400;
    color: #F8F8F8;
    // letter-spacing: 10px;

}




.dhidden{
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pageHeader {

    position: relative;
    padding-top: 68px;
    .bg, .titleArea, .descArea {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        background-size: 100% 100%;
        background-size: cover;
    }
    .bg {
        z-index: 1;
        overflow: hidden;
        // background: #D6D6D6;
        // filter: blur(10px);
        // top: 0;
        // background: linear-gradient(45deg, #8E8E8E, #DDDDDD);

    }
}
.body {
    position: relative;
    z-index: 2;
    /* alter at 2020-12-10
     */
    /*border-radius: 30px 30px 0px 0px;*/
    border-radius: 16px 16px 0px 0px;
}
.voiceCourseItem {
    padding: 12px 0;
}
.nextButton {
    background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgZmlsbDogbm9uZTsNCiAgICAgIH0NCg0KICAgICAgLmNscy0yIHsNCiAgICAgICAgZmlsbDogI2ZmMzc1MDsNCiAgICAgIH0NCiAgICA8L3N0eWxlPg0KICA8L2RlZnM+DQogIDxnIGlkPSLnu4RfMTE5NSIgZGF0YS1uYW1lPSLnu4QgMTE5NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4yMjMpIj4NCiAgICA8cmVjdCBpZD0i55+p5b2iXzQwOSIgZGF0YS1uYW1lPSLnn6nlvaIgNDA5IiBjbGFzcz0iY2xzLTEiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMjIzKSIvPg0KICAgIDxnIGlkPSLnu4RfMTE5MCIgZGF0YS1uYW1lPSLnu4QgMTE5MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCAyLjIyNSkiPg0KICAgICAgPHBhdGggaWQ9IuWkmui+ueW9ol8xMyIgZGF0YS1uYW1lPSLlpJrovrnlvaIgMTMiIGNsYXNzPSJjbHMtMiIgZD0iTTguMzczLDIuMjc4YTIsMiwwLDAsMSwzLjI1NSwwbDYuMTE0LDguNTU5QTIsMiwwLDAsMSwxNi4xMTQsMTRIMy44ODZhMiwyLDAsMCwxLTEuNjI3LTMuMTYyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQpIHJvdGF0ZSg5MCkiLz4NCiAgICAgIDxyZWN0IGlkPSLnn6nlvaJfNDA4IiBkYXRhLW5hbWU9IuefqeW9oiA0MDgiIGNsYXNzPSJjbHMtMiIgd2lkdGg9IjMiIGhlaWdodD0iMTQiIHJ4PSIxLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjc3NyAyLjc3NSkiLz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg0K') no-repeat;
    &.disabled {
        background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgb3BhY2l0eTogMC41Ow0KICAgICAgfQ0KDQogICAgICAuY2xzLTIgew0KICAgICAgICBmaWxsOiBub25lOw0KICAgICAgfQ0KDQogICAgICAuY2xzLTMgew0KICAgICAgICBmaWxsOiAjZmYzNzUwOw0KICAgICAgfQ0KICAgIDwvc3R5bGU+DQogIDwvZGVmcz4NCiAgPGcgaWQ9Iue7hF8xMTk1IiBkYXRhLW5hbWU9Iue7hCAxMTk1IiBjbGFzcz0iY2xzLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMjIzKSI+DQogICAgPHJlY3QgaWQ9IuefqeW9ol80MDkiIGRhdGEtbmFtZT0i55+p5b2iIDQwOSIgY2xhc3M9ImNscy0yIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjIyMykiLz4NCiAgICA8ZyBpZD0i57uEXzExOTAiIGRhdGEtbmFtZT0i57uEIDExOTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQgMi4yMjUpIj4NCiAgICAgIDxwYXRoIGlkPSLlpJrovrnlvaJfMTMiIGRhdGEtbmFtZT0i5aSa6L655b2iIDEzIiBjbGFzcz0iY2xzLTMiIGQ9Ik04LjM3MywyLjI3OGEyLDIsMCwwLDEsMy4yNTUsMGw2LjExNCw4LjU1OUEyLDIsMCwwLDEsMTYuMTE0LDE0SDMuODg2YTIsMiwwLDAsMS0xLjYyNy0zLjE2MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0KSByb3RhdGUoOTApIi8+DQogICAgICA8cmVjdCBpZD0i55+p5b2iXzQwOCIgZGF0YS1uYW1lPSLnn6nlvaIgNDA4IiBjbGFzcz0iY2xzLTMiIHdpZHRoPSIzIiBoZWlnaHQ9IjE0IiByeD0iMS41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi43NzcgMi43NzUpIi8+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==') no-repeat;
    }
}
.pauseButton {
    width: 14px;
    height: 20px;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDE0IDIwIj4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgZmlsbDogI2ZmMzc1MDsNCiAgICAgIH0NCiAgICA8L3N0eWxlPg0KICA8L2RlZnM+DQogIDxnIGlkPSLnu4RfMTMzMiIgZGF0YS1uYW1lPSLnu4QgMTMzMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4yMjMgMC41MDQpIj4NCiAgICA8cmVjdCBpZD0i55+p5b2iXzQxMiIgZGF0YS1uYW1lPSLnn6nlvaIgNDEyIiBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0IiBoZWlnaHQ9IjIwIiByeD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMjIzIC0wLjUwNCkiLz4NCiAgICA8cmVjdCBpZD0i55+p5b2iXzQxMyIgZGF0YS1uYW1lPSLnn6nlvaIgNDEzIiBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0IiBoZWlnaHQ9IjIwIiByeD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS43NzcgLTAuNTA0KSIvPg0KICA8L2c+DQo8L3N2Zz4NCg==');
    background-repeat: no-repeat;
}
</style>
